<style scoped>
.requireText label:before{
  content: '* ';
  color: red;
}
.ivu-btn-primary {
    color: #fff;
    background-color: #326CFB !important;
    border-color: #326CFB !important;
}
.border-light-yellow{
  border: 1px solid yellow;
  color: yellow;
}
.border-light-green{
    border: 1px solid #3CD497;
    color: #3CD497;
}
.border-red{
    border: 1px solid #FD5A5B;
    color: #FD5A5B;
}
.border-color-orange{
    border: 1px solid #FF964A;
    color: #FF964A;
}
.border-color-purple{
  border: 1px solid #0C25F1;
  color: #0C25F1;
}
.border-color-blue{
  border: 1px solid #326CFB;
  color: #326CFB;
}
.color-green{
  color: #3CD497;
}
</style>

<template>
  <div style="padding: 15px;width:100%">
    <Card >
      <Row>
        <Button class="" style="margin-bottom: 10px;" type="info" @click="backPage">返回</Button>
      </Row>
      <Row>
        <!-- border:1px solid #dcdee2; -->
        <Col >
          <Row>
            <div style="display: flex;flex-direction: row;">
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">序号：</span>{{ objFuhe._index+1 }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">订单号：</span>{{ objFuhe.code }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">产品名称：</span>{{ objFuhe.name }}
            </div>
          </div>
          </Row>
        <Row>
          <div style="display: flex;flex-direction: row;">
           
            <div style="margin-right: 20px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">宽：</span>{{ objFuhe.wide }}(mm)</div>
            <div style="margin-right:20px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">长：</span>{{ objFuhe.lengths }}(m)</div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">数量：</span>{{ objFuhe.num }}</div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">单位：</span>{{ objFuhe.unit }}</div>
            <div style="margin-right: 200px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">备注：</span>{{ objFuhe.remark }}</div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">已生产卷数：</span>{{ plaObj.reelNo }}</div>
            <div style="margin-right: 15px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold; font-size: 18px;">总长度：</span>{{ plaObj.lenght }}</div>
              <Button class="" style="padding:2px 15px;background:rgb(60, 212, 151) !important;color:white;border-color :rgb(60, 212, 151) !important" type="primary" @click="okm">完成</Button>
          </div>
        </Row>
<Row>
  &nbsp;
</Row>
        <Row>
          <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
            <FormItem class="form-item " label="" :label-width="0"
              style="width: 200px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="searchBtnNew(2)" :loading="loading">添加面纸</Button>
             
            </FormItem>
            </Form>
            <div style="color: red;width: 100%; text-align: right; font-weight: bold;">修改克重和损耗长度会影响到剩余长度，请谨慎操作！</div>
          
          <Table class="table" border  ref="tableDataOneTab" :data="tableDataOne" :columns="tableColumnsOne" :loading="loading" highlight-row
            stripe>
          </Table>
        </Row>
        <Row style="width: 100%;">
          <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
            <FormItem class="form-item " label="" :label-width="0"
              style="width: 200px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="searchBtnNew(1)" :loading="loading">添加胶</Button>
            </FormItem>
          </Form>
          <Table class="table" border ref="tableDataTwoTab" :data="tableDataTwo" :columns="tableColumnsTwo" :loading="loading" highlight-row
            stripe>
          </Table>
        </Row>
        <Row style="width: 100%;">
          <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
            <FormItem class="form-item" label="" :label-width="0"
              style="width: 200px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="searchBtnNew(0)" :loading="loading">添加底纸</Button>
            </FormItem>
          </Form>
          <div style="color: red;width: 100%; text-align: right; font-weight: bold;">修改克重和损耗长度会影响到剩余长度，请谨慎操作！</div>
          
          <Table class="table" border ref="tableDataThreeTab" :data="tableDataThree" :columns="tableColumnsThree" :loading="loading"
            highlight-row stripe>
          </Table>
        </Row>
        <Row style="width: 100%;">
          <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
            <FormItem class="form-item" label="" :label-width="0"
              style="width: 200px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="searchBtnNew(3)" :loading="loading">添加一级半成品</Button>
            </FormItem>
          </Form>
          <div style="color: red;width: 100%; text-align: right; font-weight: bold;">修改克重和损耗长度会影响到剩余长度，请谨慎操作！</div>
          
          <Table class="table" border ref="tableDataFourTab" :data="tableDataFour" :columns="tableColumnsFour" :loading="loading" highlight-row
            stripe>
          </Table>
        </Row>
        </Col>

      </Row>
    </Card>
    <Card style="margin-top: 15px;">
      <!-- <Col  style=""> -->
      <Row>
        <Form inline :label-width="110" class="basicForm" ref="searchFormEch" :model="searchFormEch">
          <FormItem class="form-item requireText" label="长度(m)" >
            <Input class="width90" style="width: 60px;" type="text" clearable v-model.trim="searchFormEch.pasteLength"
              placeholder="请输入" />
          </FormItem>
          <!-- <FormItem class="form-item" label="损耗长度(m)">
            <Input class="width90" style="width: 60px;" type="text" clearable v-model.trim="searchFormEch.lossLength"
              placeholder="请输入" />
          </FormItem> -->
          <FormItem class="form-item" label="接头数">
            <Input class="width90" style="width: 60px;" type="text" clearable v-model.trim="searchFormEch.startNo"
              placeholder="请输入" />
          </FormItem>
          <FormItem class="form-item" label="" :label-width="0" style="width: 185px;margin-left: 50px;">
            <Button class="" type="primary" @click="heChFun" :loading="loading">复合</Button>
            <Button class="" type="primary" @click="searchBtn" :loading="loading">贴标</Button>
          </FormItem>
        </Form>
      </Row>
      <Row class="" style="display: flex;
          flex-direction: column;">
        <Table class="table" border ref="tableDataSet" :data="tableData" :columns="tableColumnRight" :loading="loading" highlight-row
          stripe>
        </Table>
        <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage"
          @on-page-size-change="handlePageSizeChange" show-total show-sizer
          style="margin-top:10px;text-align: center;" />
      </Row>
      <!-- </Col> -->
    </Card>
    <Modal :title="titleType" v-model="proSelectModals" width="1200" footer-hide style="display: flex;
      flex-direction: column;">
      <Form inline :label-width="80" class="basicForm" ref="proForm">

        <FormItem class="form-item" label="产品类别" v-if="titleType == '添加一级半成品'">
            <Select v-model="proSelectForm.categoryId" class="width160" clearable filterable placeholder="请选择">
                    <Option v-for="item in productTreeData" :value="item.id" :key="item.id" :label="item.title"></Option>
                  </Select>
          </FormItem>
        <FormItem class="form-item" label="编码" v-else>
          <Input class="width160" type="text" v-model.trim="proSelectForm.goodsCode" clearable placeholder="请输入..." />
        </FormItem>

        <FormItem class="form-item" label="宽度">
          <Input class="width160" type="text" v-model.trim="proSelectForm.goodsWide" clearable placeholder="请输入..."/>
        </FormItem>
        <!-- <FormItem class="form-item" label="最大宽度">
          <Input class="width160" type="text" readonly v-model.trim="proSelectForm.maxWidth" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="类型">
          <Select v-model="proSelectForm.type" transfer clearable class="width160">
            <Option value="">全部</Option>
            <Option value="1">一级半成品</Option>
            <Option value="2">二级半成品</Option>
          </Select>
        </FormItem> -->
        <FormItem class="form-item">
          <Button type="primary" @click="findStoreGoodsList">搜索</Button>
        </FormItem>
      </Form>
      <Row class="marginTop20">
        <Table :height="600" class="table" ref="proSelectTab" border :data="proSelectData" :columns="proSelectColumns"
          highlight-row stripe>
        </Table>
      </Row>
      <Row style="display: flex;flex-direction: row; align-items: center; justify-content: center;margin-top: 10px;">
        <Button type="primary" @click="sureProBtn">添加</Button>
        <Button @click="proSelectModals = false" class="marginLeft20" style="width: 70px;margin-left: 20px;">取消</Button>
      </Row>

    </Modal>
  </div>
</template>

<script>
import { formatDate } from "@/api/util";
import { getOverallList, getCutPaperPasteOpt,updateGoods,getPasteFinishNo,findProductTreeListOM, getPasteInfo, cutPaperPasteOptAdd,getRecallPastePaper,cutCommonDecals,getPasteFinishList,updateCutPaperPasteOpt,pastePaper,getPartDeleteById,cutCommonFulfill } from '@/api/index'
export default {
  name: "fuHAdd",
  data() {
    return {
      productTreeData:[],
      searchFormEch:{},
      processData: [],
      pageNum:1,
      pageSize:10,
      total:0,
      searchForm: {},
      objFuhe: {},
      tableData: [],
      proSelectData: [],
      tableDataOne: [],
      tableDataTwo: [],
      tableDataThree: [],
      tableDataFour: [],
      proSelectModals: false,
      titleType: '',
      loading: false,
      proSelectForm:{},
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        {
          key: "name",
          title: "工序",
          align: "center",
        },
        {
          key: "complete",
          title: "已完成",
          align: "center",
        },
        {
          key: "noComplete",
          title: "未完成",
          align: "center",
        },
        {
          key: "rate",
          title: "进度",
          align: "center",
          render: (h, params) => {
            let data = params.row.rate + '%';
            return h("span", data);
          }
        },
      ],
      tableColumnsOne: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 159,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 200,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          width: 200,
        },
        {
          title: '克重(g)',
          key: 'weight',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.weight || '',
                type: 'number'
              },
              on: {
                'on-blur': e => {
                  
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.weight = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      gParam:params.row.weight,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.weight = e.target.value;
                  }
                  this.$set(_this.tableDataOne, params.index, params.row);

                }
              }
            });

          }
        },
        {
          title: '损耗长度(m)',
          key: 'lossParam',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.lossParam || 0,
                type: 'number'
              },
              on: {
                'on-blur': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.lossParam = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      lossParam:params.row.lossParam,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.lossParam = e.target.value;
                  }
                  this.$set(_this.tableDataOne, params.index, params.row);

                }
              }
            });

          }
        },
        {
          key: "remLen",
          title: "剩余长度(m)",
          align: "center",
          width: 250,
        },


        {
          title: "操作",
          key: "action",
          width: 170,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {

                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => {
                    this.recallApply(params.row);
                  }
                }
              },
                "删除"
              ),
              h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },

                                        on: {
                                            click: () => {
                                              this.printRow(params.row);
                                            }
                                        }
                                    },
                                    "贴标"
                                ),
            ]);
          }
        }
      ],
      tableColumnsTwo: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 159,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 200,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          width: 200,
        },
        {
          title: '克重(g)',
          key: 'gramWeight',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.gramWeight || '',
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.gramWeight = Number(e.target.value);
                  } else {
                    params.row.gramWeight = e.target.value;
                  }
                  this.$set(_this.tableDataTwo, params.index, params.row);

                }
              }
            });
          }
        },
        {
          title: '损耗重量(kg)',
          key: 'weight',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.weight || '',
                type: 'number'
              },
              on: {
                'on-blur': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.weight = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      lossParam:params.row.weight,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.weight = e.target.value;
                  }
                  this.$set(_this.tableDataTwo, params.index, params.row);

                }
              }
            });
          }
        },
        {
          key: "remLen",
          title: "剩余重量(kg)",
          align: "center",
          width: 250,
        },


        {
          title: "操作",
          key: "action",
          width: 170,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {

                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => {
                    this.recallApply(params.row);
                  }
                }
              },
                "删除"
              ),
              h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                              this.printRow(params.row);
                                            }
                                        }
                                    },
                                    "贴标"
                                ),
            ]);
          }
        }
      ],
      tableColumnsThree: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 159,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 200,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          width: 200,
        },
        {
          title: '克重(g)',
          key: 'weight',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.weight || '',
                type: 'number'
              },
              on: {
                'on-blur': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.weight = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      gParam:params.row.weight,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.weight = e.target.value;
                  }
                  this.$set(_this.tableDataThree, params.index, params.row);

                }
              }
            });

          }
        },
        {
          title: '损耗长度(m)',
          key: 'lossParam',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.lossParam || 0,
                type: 'number'
              },
              on: {
                'on-blur': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.lossParam = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      lossParam:params.row.lossParam,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.lossParam = e.target.value;
                  }
                  this.$set(_this.tableDataThree, params.index, params.row);

                }
              }
            });

          }
        },
        {
          key: "remLen",
          title: "剩余长度(m)",
          align: "center",
          width: 250,
        },
        {
          title: "操作",
          key: "action",
          width: 170,
          // fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {

                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => {
                    this.recallApply(params.row);
                  }
                }
              },
                "删除"
              ),
              h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                              this.printRow(params.row);
                                            }
                                        }
                                    },
                                    "贴标"
                                ),
            ]);
          }
        }
      ],
      tableColumnsFour: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed: 'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 159,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 200,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          width: 200,
        },
        {
          title: '克重(g)',
          key: 'weight',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.weight || '',
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.weight = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      gParam:params.row.weight,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.weight = e.target.value;
                  }
                  this.$set(_this.tableDataFour, params.index, params.row);

                }
              }
            });

          }
        },
        {
          title: '损耗长度(m)',
          key: 'lossParam',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.lossParam || 0,
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.lossParam = Number(e.target.value);
                    updateGoods({
                      goodsId: params.row.id,
                      lossParam:params.row.lossParam,
                    })
                      .then(res => {
                        if (res.code == 200) {
                          params.row.remLen = res.data
                        }
                      })
                  } else {
                    params.row.lossParam = e.target.value;
                  }
                  this.$set(_this.tableDataFour, params.index, params.row);

                }
              }
            });

          }
        },
        {
          key: "remLen",
          title: "剩余长度(m)",
          align: "center",
          width: 250,
        },
        {
            title: "操作",
            key: "action",
            width: 170,
            // fixed:'right',
            align: "center",
            render: (h, params) => {
              return h("div", [
              h(
                                    "button", {
                                       
                                        style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                                this.recallApply(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                ),
                                h(
                                    "button", {
                                       
                                      style: {
                                          // marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                              this.printRow(params.row);
                                            }
                                        }
                                    },
                                    "贴标"
                                ),
              ]);
            }
          }
      ],
      tableColumnRight: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed: 'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          // width: 150,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          // width: 150,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          // width: 150,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          // width: 150,
        },
        {
          key: "startNo",
          title: "接头数",
          align: "center",
          // width: 150,
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          // width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.status)) {
              case 0:
                data = "撤销";
                className = '#FF964A';
                break;
              case 1:
                data = "入库";
                className = '#3CD497';
                break;
            }

            return h(
              "button", {
                 style: {
                            marginRight: "10px",
                            display:"inline",
                            cursor: 'pointer',
                            padding:"2px 6px",
                            background:'#ffffff',
                            color:className,
                            // borderRadio:'5px',
                            border:className,
                          },
                attrs: {
                    class: className
                  }
            },
              data
            )
          }
        },
        {
          key: "operateTime",
          title: "操作时间",
          align: "center",
          // width: 150,
        },
        {
          key: "operator",
          title: "操作人",
          align: "center",
          // width: 150,
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
            h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF9900',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                                this.recallApplys(params.row);
                                            }
                                        }
                                    },
                                    "撤销"
                                ),
            ]);
          }
        }
      ],
      proSelectColumns: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 120,
        },
        {
          key: "goodsCode",
          title: "序列号",
          align: "center",
          width: 200,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 120,
        },
        {
          key: "brand",
          title: "品牌",
          align: "center",
          width: 90,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 110,
        },
        {
          key: "remLen",
          title: "长(m)",
          align: "center",
          width: 150,
        },
        {
          title: '克重(g)',
          key: 'weight',
          align: 'center',
          width: "150",
        },
        {
          title: '重量(kg)',
          key: 'remKg',
          align: 'center',
          // width: "150",
          render: (h, params) => {
              let data = (Number(params.row.remKg)).toFixed(2);
              return h('div',data)
            }
        },
      ],
      types: null,
      plaObj:{},
    }
  },
  methods: {
    okm(){
       this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:this.objFuhe.id,
                    type:0,
                  }).then( res => {
                    if(res.code == 200){
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
    },
    printRow(v){
          cutCommonDecals([v.code])
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
    heChFun(){
      const data1 = this.$refs.tableDataOneTab.getSelection();
      const data2 = this.$refs.tableDataTwoTab.getSelection();
      const data3 = this.$refs.tableDataThreeTab.getSelection();
      const data4 = this.$refs.tableDataFourTab.getSelection();
      if(data1.length == 0 &&data2.length == 0 &&data3.length == 0 &&data4.length == 0){
        this.$Message.error('请勾选需要复合的材料!');
        return
      }
      if(!this.searchFormEch.pasteLength){
        this.$Message.error('请填写长度!');
        return
      }
      pastePaper({
        facePaperList:data1, //面纸列表
        glueList:data2,//胶水列表
        basePaperList:data3,//底纸列表
        proPaperList:data4,//半成品列表
        startNo:this.searchFormEch.startNo,
        pid:this.objFuhe.id,
        pasteLength:this.searchFormEch.pasteLength,
        lossLength:this.searchFormEch.lossLength,
      }).then(res => {
        if(res.code == 200){
          this.$Message.success('复合成功!');
          this.getCutPaperPasteOptFun()
          this.getCutPaperPasteListFun()
        }
      })
    },
    getPasteFinishNoFun(){
      getPasteFinishNo({
        pId:this.objFuhe.id
      }).then(res => {
        if(res.code == 200){
          this.plaObj = res.data
        }
      })
    },
    getCutPaperPasteListFun(){
      let params = {
        data:{
          parentId:this.objFuhe.id
        },
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      getPasteFinishList(params).then(res => {
        if(res.code == 200){
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    recallApply(v) {

      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除吗?",
        onOk: () => {
          let params = {
            id: v.id,
          }
          getPartDeleteById(params)
            .then(res => {
              if (res.code == 200) {
                this.$Message.success('删除成功!');
                this.getCutPaperPasteOptFun()
              }
            })
        }
      });

    },
    recallApplys(v) {

this.$Modal.confirm({
  title: "确认撤销",
  content: "您确认要撤销吗?",
  onOk: () => {
    let params = {
      id: v.id,
    }
    getRecallPastePaper(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('撤销成功!');
          this.getCutPaperPasteListFun()
        }
      })
  }
});

},
    sureProBtn() {
      const data = this.$refs.proSelectTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      data.map(item => {
        item.stockId = item.id
        item.parentId = this.objFuhe.id
        item.type = this.types
      })
      // let params = {
      //   data
      // }
      cutPaperPasteOptAdd(data).then(res => {
        if (res.code == 200) {
          this.$Message.success('保存成功！');
          this.proSelectModals = false
          this.getCutPaperPasteOptFun()
        }
      })
    },
    updateGoodsClick(row) {
      updateGoods({
        goodsId: row.id,
        gParam:row.weight
      })
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            console.log(res.data);
            this.proSelectData = res.data;
          }
        })
    },
    findStoreGoodsList() {
      getPasteInfo({
        ...this.proSelectForm,
        id: this.objFuhe.id,
        type: this.types,

      }).then(res => {
        if (res.code == 200) {
          this.proSelectData = res.data
        }
      })
    },
    handleChangePage(page) {
                this.pageNum = page;
                this.getCutPaperPasteListFun()
            },
            handlePageSizeChange(size) {
                this.pageSize = size;
                this.getCutPaperPasteListFun()
            },
    searchBtnNew(type) {
      this.types = type
      this.proSelectForm = {}
      switch (type) {
        case 2:
          this.titleType = "添加面纸";
          break;
        case 1:
          this.titleType = "添加胶";
          break;
        case 0:
          this.titleType = "添加底纸";
          break;
        case 3:
          this.titleType = "添加一级半成品";
          break;
      }
      this.proSelectModals = true
      getPasteInfo({
        id: this.objFuhe.id,
        type: type
      }).then(res => {
        if (res.code == 200) {
          this.proSelectData = res.data
        }
      })
    },
    getCutPaperPasteOptFun() {
      getCutPaperPasteOpt({
        pId: this.objFuhe.id
      })
        .then(res => {
          if (res.code == 200) {
            this.tableDataOne = []
            this.tableDataTwo = []
            this.tableDataThree = []
            this.tableDataFour = []

            res.data.map(item => {
              switch (item.type) {
                case 2:
                  this.tableDataOne.push(item);
                  break;
                case 1:
                  this.tableDataTwo.push(item);
                  break;
                case 0:
                  this.tableDataThree.push(item);
                  break;
                case 3:
                  this.tableDataFour.push(item);
                  break;
              }
            })
          }
        })
    },
    searchBtn(){
      const data = this.$refs.tableDataSet.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let codeArr = []
      data.map(item => {
        codeArr.push(item.code)
      })
      cutCommonDecals(codeArr).then(res => {
        if (res.code == 200) {
          window.open(res.data.result,"_blank");
        }
      })
    },
    // searchBtn(){
    //   this.tableData = []
    //   let params = {
    //     ...this.searchForm,
    //     startTime:this.searchForm.startDate ?
    //       formatDate(this.searchForm.startDate, "yyyy-MM-dd hh:mm:ss") : "",
    //     endTime:this.searchForm.endDate ?
    //       formatDate(this.searchForm.endDate, "yyyy-MM-dd hh:mm:ss") : "",
    //   }
    //   getOverallList(params)
    //     .then(res => {
    //       if(res.code == 200){
    //           this.tableData = res.data;
    //       }
    //     })
    // },
    backPage() {
      this.$router.go(-1);
    },
    init() {
      // 初始化时间为当天
      let eTime = new Date();
      eTime.setHours("23");
      eTime.setMinutes("59");
      eTime.setSeconds("59");
      this.searchForm.endDate = eTime;
      let newTime = new Date();
      newTime.setHours("00");
      newTime.setMinutes("00");
      newTime.setSeconds("00");
      this.searchForm.startDate = newTime;
    },
    omtFun(){
      findProductTreeListOM().then( res => {
        if(res.code == 200){
          this.productTreeData = (res.data).reduce((acc, item) => {
  if (item.children) acc.push(...item.children);
  return acc;
}, []);
          console.log("this.productTreeData",this.productTreeData,res.data);
        }
      })
    }
  },
  mounted() {
    this.omtFun()
    this.init()
    this.objFuhe = JSON.parse(window.sessionStorage.getItem('objFuhe'))
    console.log("objFuhe", this.objFuhe);
    
    this.getPasteFinishNoFun()
    this.getCutPaperPasteOptFun()
    this.getCutPaperPasteListFun()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/fuHAdd.vue